/**
 * Persistence for Off-Ramp Check (DIP — page depends on this helper, not raw localStorage).
 */
import type { JobId } from './types';

const JOB_KEY = 'flowguard-offramp-job';
const TIP_KEY = 'flowguard-offramp-tip-seen';

const VALID_JOBS: JobId[] = ['name_exit', 'clear_freeze', 'show_all'];

function isJobId(value: string | null): value is JobId {
    return value !== null && (VALID_JOBS as string[]).includes(value);
}

export function readStoredJob(): JobId | null {
    try {
        const raw = localStorage.getItem(JOB_KEY);
        return isJobId(raw) ? raw : null;
    } catch {
        return null;
    }
}

export function writeStoredJob(jobId: JobId): void {
    try {
        localStorage.setItem(JOB_KEY, jobId);
    } catch {
        /* ignore quota / private mode */
    }
}

export function clearStoredJob(): void {
    try {
        localStorage.removeItem(JOB_KEY);
    } catch {
        /* ignore */
    }
}

export function isTipSeen(): boolean {
    try {
        return localStorage.getItem(TIP_KEY) === '1';
    } catch {
        return false;
    }
}

export function markTipSeen(): void {
    try {
        localStorage.setItem(TIP_KEY, '1');
    } catch {
        /* ignore */
    }
}
